import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrid2 } from "@fortawesome/pro-regular-svg-icons/faGrid2";
import { buttonVariants } from "theme/buttonVariants";
import cn from "classnames";

const Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faGrid2} size="6x" />
    </div>
);

const PanelGridComponent = ({
    state: { panels = [], heading = "", selectedCardIndex = null },
    isEditMode,
    onChange,
    focused,
}) => {
    return (
        <div>
            <div className="flex flex-col items-center justify-between md:flex-row mb-[30px]">
                <h2
                    data-testid="product-relations__title"
                    className={
                        "text-center !text-[30px] !leading-[34px] text-brand-black !lg:text-[40px] !lg:leading-[46px] !mb-0"
                    }
                >
                    {heading}
                </h2>
            </div>

            {panels?.length > 0 ? (
                <div className="grid gap-[15px] grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {panels.map((panel, idx) => {
                        return (
                            <div
                                key={`panels_${idx}`}
                                data-testid={`panels__item-${idx}`}
                                style={{
                                    boxShadow:
                                        selectedCardIndex === idx &&
                                        focused &&
                                        "inset 0 0 0 3px red",
                                    backgroundImage: panel.backgroundImage
                                        ? `url("${panel.backgroundImage}")`
                                        : "none",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                }}
                                className={`flex py-[50px] px-[30px] flex-col w-full gap-y-[15px] bg-brand-light-grey`}
                                onClick={(e) => {
                                    if (isEditMode) {
                                        e.preventDefault();
                                        onChange({
                                            selectedCardIndex: idx,
                                        });
                                    }
                                }}
                            >
                                <div className="w-full h-full relative flex flex-col gap-y-[15px] items-center justify-start text-brand-white">
                                    <h3 className="text-center">
                                        {panel.heading}
                                    </h3>

                                    <p
                                        className=" text-[16px] leading-[22px] mb-0 text-center flex-grow"
                                        dangerouslySetInnerHTML={{
                                            __html: panel.text,
                                        }}
                                    />

                                    {panel.buttonLink && (
                                        <a
                                            href={panel.buttonLink}
                                            className={cn(
                                                buttonVariants[
                                                    panel.buttonColour
                                                ].solidClasses,
                                                "!text-brand-white !no-underline hover:text-brand-white !hover:font-bold !border-transparent !font-bold"
                                            )}
                                        >
                                            {panel.buttonText}
                                        </a>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <Icon />
            )}
        </div>
    );
};

export default PanelGridComponent;
